import axios from "axios";
import { combinedUrls } from "../../../../../URL/functions";
import { projectUrls } from "../../../../../URL/ApplicationUrls";

export default async function RemoveSpdrCommand(
  projectId: number,
  spdrId: number
) {
  const url = combinedUrls(
    projectUrls.base.apiUrl,
    `${projectId}/RemoveSpdr/${spdrId}`
  );

  const response = await axios.delete(url);
  if (response.status !== 200) {
    throw new Error("Network response was not ok");
  }
}
